import Footer from "../components/layout/Footer";
import Header from "../components/layout/Header";
import portada from "../assets/portada.png";
import locationIcon from "../assets/location.png";
import telIcon from "../assets/tel.png";
import mailIcon from "../assets/mail.png";
import Cart from "../assets/cart.png";
import { useTitle } from "../hooks/useTitle";
import CarritoCompras from "../components/CarritoCompras";
import { useState, useEffect } from "react";
import Whatsapp from "../assets/Whatsapp.svg"
import { Helmet } from "react-helmet-async";

import { useForm } from "../hooks/useForm";
import { useLocation } from "react-router-dom";
import WaComponent from "../components/WaComponent";

const Contacto = () => {

    
    const { pathname }  = useLocation()
    
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    const [openCart, setOpenCart] = useState(false);
    const title = `Contactanos`;
    const description = `¿Tienes preguntas o necesitas ayuda? Contáctanos fácilmente a través de nuestro formulario, teléfono o correo electrónico. Estamos aquí para ayudarte con todo lo relacionado con bicicletas.`;

    useTitle({ title, description });

    const { form, onChange } = useForm({ name: '', email: '', message: '' });
    const { name, email, message } = form;

    const handleSendEmail = (e) => {
        e.preventDefault();
        const mailtoLink = `mailto:deliarosaro113@gmail.com?subject=Informe de bicicletas&body=Nombre: ${name}%0D%0AMensaje: ${message}`;
        window.location.href = mailtoLink;
    }

    return (
        <>
            <Helmet prioritizeSeoTags={true}>
                <title>{`${title} | Bicicletas java colombia`}</title>
                <meta property="og:type" content="website" />
                <meta property="og:title" content={`${title} | Bicicletas java colombia`} />
                <meta property="og:url" content="https://bicicletasjavacolombia.com/" />
                <meta property="og:image" content="https://bicicletasjavacolombia.com/src/assets/logo-footer.png" />
                <meta property="og:description" content={`${description}`} />
            </Helmet>
            <div className="" style={{ maxWidth: "100%", background: "#000000" }}>
                <Header setOpenCart={setOpenCart} openCart={openCart} />
                    <WaComponent></WaComponent>
                <Footer />
            </div >

        </>
    );
}

export default Contacto;